module.exports = __webpack_public_path__ + "static/media/18ECA46.ce6bc8c3.jpg";